import { RoomDetailsState, RoomFormDataActionTypes, ROOM_DETAILS_FAILURE, ROOM_DETAILS_REQUEST, ROOM_DETAILS_SUCCESS } from "store/reducers/room/get-details/types";

const defaultState: RoomDetailsState = {
  isLoading: false,
  errorMessage: ""
};

export default function getRoomDetails(state = defaultState, action: RoomFormDataActionTypes): RoomDetailsState {
  switch (action.type) {
    case ROOM_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ROOM_DETAILS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case ROOM_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};